import { ROUTE_OFFERS, ROUTE_POINTS_INFO } from '@1bill-app/constants';
import { RewardQuery } from '@1bill-app/services/reward/reward.query';
import { Reward, RewardState } from '@1bill-app/services/reward/reward.type';
import {
  animate,
  state, style, transition, trigger
} from '@angular/animations';
import { Component, Input, OnInit } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { PopoverAchievementsComponent } from '../popover-achievements/popover-achievements.component';

@Component({
  selector: 'app-achievements-list',
  templateUrl: './achievements-list.component.html',
  styleUrls: ['./achievements-list.component.scss'],
  animations: [
    trigger('visibilityChanged', [
      state('shown', style({ opacity: 1 })),
      state('hidden', style({ opacity: 0 })),
      transition('* => *', animate('.5s'))
    ])
  ]
})

export class AchievementsListComponent implements OnInit {
  pointsInfoRoute = ROUTE_POINTS_INFO;
  offersRoute = ROUTE_OFFERS;
  constructor(private popoverController: PopoverController, private rewardQuery: RewardQuery) { }

  @Input() set rewardState(state: RewardState) {
    this.filteredRewards = state.rewards.filter(
      (reward) => reward.showBadge == 1 && reward.completed == 1,
    );
  }
  public filteredRewards: Reward[];
  visibility = 'hidden';
  totalPointsBalance: number = null;

  ngOnInit() {
    this.rewardQuery.select('totalPointsBalance').subscribe((pointsBalance) => {
      this.totalPointsBalance = pointsBalance ?? null;
    })
  }

  async presentPopover(reward: Reward) {
    const popover = await this.popoverController.create({
      component: PopoverAchievementsComponent,
      cssClass: 'my-custom-class',
      // translucent: true,
      mode: 'ios',
      componentProps: {
        reward: reward,
      },
    });
    return await popover.present();
  }

  changevisibility() {
    this.visibility = this.visibility == 'hidden' ? 'shown' : 'hidden';
  }
}
